export const RETURNS_GRID_GET_RETURNS_REQUEST = 'RETURNS_GRID_GET_RETURNS_REQUEST';
export const getReturns = () => ({
  type: RETURNS_GRID_GET_RETURNS_REQUEST,
});

export const RETURNS_GRID_GET_SILENT_RETURNS_REQUEST = 'RETURNS_GRID_GET_SILENT_RETURNS_REQUEST';
export const getReturnsSilently = () => ({
  type: RETURNS_GRID_GET_SILENT_RETURNS_REQUEST,
});

export const RETURNS_GRID_GET_RETURNS_SUCCESS = 'RETURNS_GRID_GET_RETURNS_SUCCESS';
export const getReturnsSuccess = (returns, page, pageSize, totalCount) => {
  return {
    type: RETURNS_GRID_GET_RETURNS_SUCCESS,
    returns,
    page,
    pageSize,
    totalCount,
  };
};

export const RETURNS_GRID_GET_RETURNS_FAILURE = 'RETURNS_GRID_GET_RETURNS_FAILURE';
export const getReturnsFailure = (error) => {
  return {
    type: RETURNS_GRID_GET_RETURNS_FAILURE,
    ...error,
  };
};

export const RETURNS_OPEN_EMAIL_RETURN_LABEL_MODAL = 'RETURNS_OPEN_EMAIL_RETURN_LABEL_MODAL';
export const openEmailReturnLabelModal = (returns) => ({
  type: RETURNS_OPEN_EMAIL_RETURN_LABEL_MODAL,
  returns,
});

export const RETURNS_SEND_LABEL_TO_EMAIL_REQUEST = 'RETURNS_SEND_LABEL_TO_EMAIL_REQUEST';
export const sendReturnLabelToEmail = (emails) => ({
  type: RETURNS_SEND_LABEL_TO_EMAIL_REQUEST,
  emails,
});

export const RETURNS_LABEL_EMAIL_PROCESSING_SUCCESS = 'RETURNS_LABEL_EMAIL_PROCESSING_SUCCESS';
export const processingReturnLabelsEmailSuccess = (statuses) => ({
  type: RETURNS_LABEL_EMAIL_PROCESSING_SUCCESS,
  statuses,
});

export const RETURNS_LABEL_EMAIL_PROCESSING_FAILURE = 'RETURNS_LABEL_EMAIL_PROCESSING_FAILURE';
export const processingReturnLabelsEmailFailure = (errors) => ({
  type: RETURNS_LABEL_EMAIL_PROCESSING_FAILURE,
  errors,
});

export const RETURNS_OPEN_VOID_AND_CANCEL_MODAL = 'RETURNS_OPEN_VOID_AND_CANCEL_MODAL';
export const openVoidAndCancelReturnModal = (fulfillmentIds, fromOrderDetails = false) => ({
  type: RETURNS_OPEN_VOID_AND_CANCEL_MODAL,
  fulfillmentIds,
  fromOrderDetails,
});

export const RETURNS_VOID_LABEL_REQUEST = 'RETURNS_VOID_LABEL_REQUEST';
export const voidReturnLabelRequest = (fulfillmentIds, fromOrderDetails = false) => ({
  type: RETURNS_VOID_LABEL_REQUEST,
  fulfillmentIds,
  fromOrderDetails,
});

export const RETURNS_VOID_LABEL_SUCCESS = 'RETURNS_VOID_LABEL_SUCCESS';
export const voidReturnLabelSuccess = (responses, fulfillmentIds, fromOrderDetails = false) => ({
  type: RETURNS_VOID_LABEL_SUCCESS,
  responses,
  fulfillmentIds,
  fromOrderDetails,
});

export const RETURNS_VOID_LABEL_FAILURE = 'RETURNS_VOID_LABEL_FAILURE';
export const voidReturnLabelFailure = (error) => ({
  type: RETURNS_VOID_LABEL_FAILURE,
  error,
});

export const RETURNS_MARK_AS_RECEIVED_REQUEST = 'RETURNS_MARK_AS_RECEIVED_REQUEST';
export const markAsReceivedRequest = (selectedReturns, receivedDateTime, isFromGrid) => ({
  type: RETURNS_MARK_AS_RECEIVED_REQUEST,
  selectedReturns,
  receivedDateTime,
  isFromGrid,
});

export const RETURNS_DOWNLOAD_RETURN_LABEL = 'RETURNS_DOWNLOAD_RETURN_LABEL';
export const downloadReturnLabel = (fulfillmentId) => ({
  type: RETURNS_DOWNLOAD_RETURN_LABEL,
  fulfillmentId,
});

export const RETURNS_CREATE_LABEL = 'RETURNS_CREATE_LABEL';
export const createReturnLabel = ({ shippingConfiguration, emailTo, rmaNumber, metadata }) => ({
  type: RETURNS_CREATE_LABEL,
  shippingConfiguration,
  emailTo,
  rmaNumber,
  metadata,
});

export const RETURNS_CREATE_LABEL_SUCCESS = 'RETURNS_CREATE_LABEL_SUCCESS';
export const createReturnLabelSuccess = (shippingConfiguration, fulfillmentId, metadata) => ({
  type: RETURNS_CREATE_LABEL_SUCCESS,
  shippingConfiguration,
  fulfillmentId,
  metadata,
  fulfillmentPlanId: (metadata || {}).fulfillmentPlanId,
});

export const RETURNS_CREATE_LABEL_FAILURE = 'RETURNS_CREATE_LABEL_FAILURE';
export const createReturnLabelFailure = (shippingConfiguration, errorMessages, metadata) => ({
  type: RETURNS_CREATE_LABEL_FAILURE,
  shippingConfiguration,
  errorMessages,
  metadata,
  fulfillmentPlanId: (metadata || {}).fulfillmentPlanId,
});

export const EXPORT_RETURNS = 'EXPORT_RETURNS';
export const exportReturns = (fulfillmentIds) => ({
  type: EXPORT_RETURNS,
  fulfillmentIds,
});

export const RETURNS_ADVANCED_SEARCH_BULKLOAD_ENTITIES_REQUEST = 'RETURNS_ADVANCED_SEARCH_BULKLOAD_ENTITIES_REQUEST';
export const bulkloadAdvancedSearchEntities = (returns, page, pageSize, totalCount, currentPageFulfillmentIds) => ({
  type: RETURNS_ADVANCED_SEARCH_BULKLOAD_ENTITIES_REQUEST,
  returns,
  page,
  pageSize,
  totalCount,
  currentPageFulfillmentIds,
});
